import React, { useEffect, useState } from "react";
import Config from "../Config";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import PhoneInput from "react-phone-input-2";
import { useAuthHandling } from '../useAuthhandling';
import AdminFormPage from "../AdminFormPage";
import FieldError from "../FieldError";
import { useAppFeedback } from "../useAppFeedback";

import "react-phone-input-2/lib/style.css";
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLocationType("ROOFTOP");

function Customeredit() {
  const { handleUnauthorized } = useAuthHandling();
  const { showError, showSuccess } = useAppFeedback();
  const [prof, setProf] = useState([]);
  const [mobile, setMobile] = useState();

  const [addressstring, setaddressstring] = useState("");

  const [location, setLocation] = useState([]);
  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});

  const [countrycodeval,setCountrycodeval]=useState('');
  const [loginValuenewph,setLoginValuenewph]=useState('');
  const [suspended,setSuspended]=useState(false);


  let { id } = useParams();

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setProf({ ...prof, [name]: value });
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.name) {
      errors.name = "Name is required!";
    }

    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }

    // if (!values.password) {
    //   errors.password = "password is required!";
    // }
    // if (!values.cpassword) {
    //   errors.cpassword = "confirm password is required!";
    // }

    return errors;
  };
  const validate1 = (values) => {
    const errors = {};
    if (values < 4) {
      errors.mobile = "Contact number required!";
    }
    return errors;
  };
  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/customer-info/${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();

      setProf(data.data);
      setMobile("+" + data.data.countryCode + data.data.mobile);
      setSuspended(data?.data?.suspended);
      setLoginValuenewph(data?.data?.mobile);
      setCountrycodeval(data?.data?.countryCode);
      // setMobile("+" + data.data.mobile);
      setLocation({
        name: data.data.location,
        lat: data.data.locationKey.coordinates[0],
        long: data.data.locationKey.coordinates[1],
      });
      setaddressstring(data.data.google_address_string);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  const handleInputsphone = (phone,country) => {
    let value =phone;
    setMobile(phone);
    setCountrycodeval(country.dialCode);
    const phoneWithoutCode = value.replace(`+${country.dialCode}`, "").trim();
    setLoginValuenewph(phoneWithoutCode);

  }

  const PostData = async (e) => {
    e.preventDefault();
    const ress = validate(prof);
    const ress1 = validate1(mobile);

    setError(ress);
    setError1(ress1);

    // axios.post(`${Config.apiurl}/api/v1/crm/professional/create-professional`, formData, { headers: {
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    // },})
    if (!ress.email && !ress.name && !ress1.mobile) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/customer/update-customer/${id}`,
        {
          method: "PUT",

          body: JSON.stringify({
            name: prof.name,
            email: prof.email,
            // mobile: mobile,
            mobile: loginValuenewph,
            countryCode:countrycodeval,
            password: '#testPass1',
            confirmPassword: '#testPass1',
            // password: pass.password,
            // confirmPassword: pass.cpassword,
            suspended:suspended,
            location: location.name,
            latitude: location.lat,
            longitude: location.long,
            google_address_string: addressstring,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );

      if (res.status === 200) {
        await res.json();
        showSuccess("Sucessfully Updated Account", {
          redirectTo: "/customerdetails",
        });
      } else if(res.status === 401){
        handleUnauthorized();
      } else {
        const data = await res.json();
        showError(data.message);      
      }
    }
  };

  const handleChange = async (value) => {
    setLocation({
      name: value,
      lat: location.lat,
      long: location.long,
    });
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    Geocode.fromLatLng(latLng.lat, latLng.lng).then((response) => {
      const address = response.results[0].formatted_address;
      setaddressstring(address);
    });
    setLocation({
      name: value,
      lat: latLng.lat,
      long: latLng.lng,
    });
  };

  // const handleInputsphone = (value) => {
  //   setMobile(value);
  // };
  useEffect(() => {
    getinfo();
    //    function getloc() {
    //     navigator.geolocation.getCurrentPosition(function(position) {
    //       console.log("Latitude is :", position.coords.latitude);
    //       console.log("Longitude is :", position.coords.longitude);
    //      getWeather(position.coords.latitude, position.coords.longitude);
    //     })
    //   }
    //   getloc();

    // const  getWeather = async (lat, long) => {

    //   const api_call = await fetch(
    //         `${apiKeys.base}weather?lat=${lat}&lon=${long}&units=metric&APPID=${apiKeys.key}`
    //     );
    //     const data = await api_call.json();
    //     setLocation(data);
    //   }
  }, []);
  return (
    <AdminFormPage title="User Edit">
      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            name="name"
                            value={prof.name}
                            onChange={handleInputs}
                            required
                          />
                          <FieldError message={formerror.name} />
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email"
                            name="email"
                            value={prof.email}
                            onChange={handleInputs}
                            required
                          />
                          <FieldError message={formerror.email} />
                        </div>
                        <div className="row">

                        
                        <div className="form-group number col-md-6">
                          <label htmlFor="exampleInputUsername1">Mobile</label>
                          {/* <input
                            type="number"
                            className="form-control "
                            placeholder="Mobile"
                            name="mobile"
                            value={mobile}
                            onChange={handleInputs}
                            required
                          /> */}
                          <PhoneInput
                            country={"in"}
                            enableSearch={true}
                            value={mobile}
                            onChange={ handleInputsphone}
                            // onChange={(phone) => handleInputsphone(phone)}
                          />
                          <FieldError message={formerror1.mobile} />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                             Suspended ?
                            </label>
                            <select
                              id="professionalType"
                              className="form-control"
                              name="suspended"
                              onChange={(e) => setSuspended(e.target.value)}
                              style={{ color: "black",height:"35px" }}
                              value={suspended}
                              
                            >
                              <option>Select</option>
                              <option name="suspended" value={true}>
                                True
                              </option>
                              <option name="suspended" value={false}>
                                False
                              </option>
                            </select>
                          </div>
                          </div>
                        {/* <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Password"
                            name="password"
                            value={pass.password}
                            onChange={handleInput}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Confirm password"
                            name="cpassword"
                            value={pass.cpassword}
                            onChange={handleInput}
                            required
                          />
                        </div> */}

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Location
                          </label>
                          <PlacesAutocomplete
                            value={location.name}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            name="location"
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div className="position-relative">
                                <input
                                  className="form-control"
                                  {...getInputProps({
                                    placeholder: " Enter your location",
                                  })}
                                  required
                                />

                                <div className="autocomplete-dropdown-container">
                                  {loading ? <div>...Loading</div> : null}

                                  {suggestions.map((suggestion, key) => {
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          border: "1px solid #d2d2d2",
                                        };

                                    return (
                                      <div
                                        className="form-conterol"
                                        {...getSuggestionItemProps(suggestion, {
                                          style,
                                        })}
                                        key={key}
                                      >
                                        {suggestion.description}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                          {/* <input className="form-control" id="location" type="text"  name="location" placeholder="Location" autoComplete='off' required value={location.name}/> */}
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                      </form>
    </AdminFormPage>
  );
}
export default Customeredit;
